import React from 'react';
import { StyledHeaderWrapper, StyledActionSheet, StyledOverlay, StyledBodyWrapper, StyledActionSheetDash } from './style';
import Text from '../Text';
var ActionSheet = function (_a) {
    var headerTitle = _a.headerTitle, children = _a.children, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen;
    var handleCloseParent = function () {
        setIsOpen(false);
    };
    var handleChildClosePrevention = function (e) {
        e.stopPropagation();
    };
    var isHeaderShown = !!headerTitle;
    return (React.createElement(StyledOverlay, { onClick: handleCloseParent, isOpen: isOpen },
        React.createElement(StyledActionSheet, { onClick: handleChildClosePrevention, isOpen: isOpen, isHeaderShown: isHeaderShown },
            React.createElement(StyledActionSheetDash, null),
            isHeaderShown && (React.createElement(StyledHeaderWrapper, null,
                React.createElement(Text, { variant: "subHeader" }, headerTitle))),
            React.createElement(StyledBodyWrapper, null, children))));
};
export default ActionSheet;
